// FILE: src/services/publish.js (FULLY UPDATED)

import axiosServices from "./axios";

// Post API (Handles ALL actions: Publish, Schedule, Draft)
export const postApi = async (payload) => {
  console.log('[postApi] Service function initiated with payload:', payload);

  try {
    if (!payload.groupId) throw new Error("Group ID is missing from the payload.");
    if (payload.status !== 'draft' && !payload.selectedProfiles?.length) {
      throw new Error("No profiles were selected for this post.");
    }
    if (!payload.media_items?.length && !payload.message?.trim()) {
      throw new Error("A post must have either media or a caption.");
    }

    // --- START: THIS IS THE FIX ---
    // The payload sent to the backend now explicitly includes platformOptions.
    const backendPayload = {
      groupId: payload.groupId,
      groupName: payload.groupName,
      media_items: payload.media_items,
      media_type: payload.media_type,
      selectedProfiles: payload.selectedProfiles,
      platforms: payload.platforms,
      message: payload.message,
      first_comment: payload.first_comment,
      board_id: payload.board_id,
      title: payload.title,
      description: payload.description,
      pinterest_thumbnail_url: payload.pinterest_thumbnail_url,
      platformOptions: payload.platformOptions, // This line is the fix
      status: payload.status,
      scheduledTime: payload.scheduledTime
    };
    
    console.log('[postApi] Sending payload to unified /schedule-posting endpoint:', backendPayload);
    const response = await axiosServices.post("/group/schedule-posting", backendPayload);
    // --- END: THIS IS THE FIX ---
    
    return [response.data];

  } catch (error) {
    console.error("[postApi] CRITICAL ERROR:", error);
    // This is the key part that lets the UI catch the limit error
    if (error.response?.status === 403 && error.response?.data?.errorType === 'LIMIT_REACHED') {
      throw error;
    }
    throw new Error(error.response?.data?.error || error.message || "Failed to process post request.");
  }
};


// Get Pinterest Board List
export const getBoardApi = async (boardID) => {
  try {
    const response = await axiosServices.post(`/pinterest/get-board`, {
      user_id: boardID
    });
    return { error: false, data: response.data.items };
  } catch (error) {
    return { error: true, message: error?.response?.data?.message || error?.message };
  }
};
export const getPost = async (data) => {
  try {
    let response = await axiosServices.post(`/posts/get-filtered`, data);
    return { error: false, data: response };
  } catch (error) {
    return { error: true, message: error?.response?.data?.message || error?.message };
  }

};

// Create Pinterest Board
export const createBoardApi = async ({ DefaultBoard, newBoardName, newBoardDes }) => {
  if (!newBoardName) return { error: true, message: "Enter Board Name" };

  try {
    const response = await axiosServices.post(`/pinterest/create-board`, {
      user_id: DefaultBoard,
      name: newBoardName,
      description: newBoardDes,
      privacy: "PUBLIC"
    });

    return { error: false, data: response.data };
  } catch (error) {
    return { error: true, message: error?.response?.data?.message || error?.message };
  }
};

// --- START: NEW FUNCTION ---
// Create YouTube Playlist
export const createPlaylistApi = async (payload) => {
    if (!payload.title) return { error: true, message: "Playlist title is required." };
    try {
        const response = await axiosServices.post('/youtube/create-playlist', payload);
        return { error: false, data: response.data };
    } catch (error) {
        return { error: true, message: error?.response?.data?.error || "Failed to create playlist." };
    }
};
// --- END: NEW FUNCTION ---

export const getScheduledData = async (name) => {
  try {
    let response = await axiosServices
      .get(
        `${process.env.REACT_APP_BACKEND_API
        }/schedule/get-all/${name}`,

      )
    return { error: false, data: response.data };

  } catch (error) {
    return { error: true, message: error?.response?.data?.message || error?.message };
  }
};


export const importFileService = async (file, groupName, selectedProfiles, platforms) => {
  try {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("groupName", groupName);

    selectedProfiles.forEach((profile) => {
      formData.append("selectedProfiles", profile.platform_id);
    });

    platforms.forEach((platform) => {
      formData.append("platforms", platform);
    });


    const response = await axiosServices.post(`/schedule/upload-schedules`, formData);

    return { success: true, data: response.data };
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || "Error importing file"
    };
  }
};
export const generateTaskService = async () => {
  try {

    const response = await axiosServices.post(`/task/generate`, {});

    return { success: true, data: response.data.data };
  } catch (error) {
    return { success: false, message: error.response?.data?.message || "Error generating task" };
  }
};
export const getPostDataService = async (platformType, selectedPlatform, groupName) => {
  try {

    if (!platformType || !selectedPlatform) {
      throw new Error("Platform type and selected profiles are required");
    }

    let platformSelected = [];

    selectedPlatform.forEach((elem) => {
      if (elem.platform === "FACEBOOK") {
        platformSelected.push(elem.platform_pageId);
      } else {
        platformSelected.push(elem.platform_id);
      }
    });

    const response = await axiosServices.post(
      `/posts/get-all`,
      {
        platform: platformType,
        groupName,
        user_id: platformSelected,
      }
    );

    return { success: true, data: response.data.Posts };
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || "Error fetching posts"
    };
  }
};
export const getGeneratedTaskService = async () => {
  try {

    const response = await axiosServices.get(`/task/get`);

    const tasks = response.data.tasks || [];
    return { success: true, data: tasks.length ? tasks[0].details : [] };
  } catch (error) {
    return { success: false, message: error.response?.data?.message || "Error fetching generated tasks" };
  }
};

export const updateScheduledPost = async (postId, data) => {
  try {
    const response = await axiosServices.patch(`/schedule/update/${postId}`, data);
    return response.data;
  } catch (error) {
    console.error('Error updating scheduled post:', error);
    // Propagate the specific limit error for the UI to handle
    if (error.response?.status === 403 && error.response?.data?.errorType === 'LIMIT_REACHED') {
      throw error;
    }
    throw new Error(error.response?.data?.message || "Failed to update post.");
  }
};